import { useT } from "../../i18n/index.js";

import {
  acceptedDisplayKey,
  acceptedIssueOf,
  refineSeedDisplayKey,
  refineSeedIssueOf,
} from "./acceptMessage";

export function UserMessage({ text }: { readonly text: string }) {
  const t = useT();
  // The two protocol messages a click sends show what the user did: the accept
  // (never its acceptToken — see acceptedIssueOf) and the refine seed.
  const accepted = acceptedIssueOf(text);
  const seeded = accepted === null ? refineSeedIssueOf(text) : null;
  const shown =
    accepted !== null
      ? t(acceptedDisplayKey, { iid: accepted })
      : seeded !== null
        ? t(refineSeedDisplayKey, { iid: seeded })
        : text;
  return (
    <div className="flex justify-end">
      <div className="max-w-[80%] rounded-lg bg-primary px-3 py-2 text-sm text-on-solid">
        <div className="whitespace-pre-wrap">{shown}</div>
      </div>
    </div>
  );
}
